import { brToNl } from "./parsing";

export const eventSteps = [
  {
    label: 'Edit Event',
    active: true,
    completed: false,
  },
  {
    label: 'Omnichannel Preview',
    active: false,
    completed: false,
  },
  {
    label: 'Schedule Invite',
    active: false,
    completed: false,
  },
  // {
  //   label: 'Schedule Invite',
  //   active: false,
  //   completed: false,
  // },
]

export const getSteps = (step) => {
  eventSteps[step].active = true;
  return eventSteps;
}

export const updateStepper = (completed, status) => {
  let steps = [];
  eventSteps.forEach((step, i) => {
    if (i === completed) {
      step.active = true;
    }
    else step.active = false;
    steps.push(step)
  })
  //canceled, : archived

  if (status === "draft" || status === "publish_scheduled" || status === "published" || status === "invite_scheduled" || status === "invited" || status === 'to_be_approved') {
    eventSteps[0].completed = true
    eventSteps[1].completed = true
    eventSteps[2].completed = false
    // if (status === "publish_scheduled" || status === "published" || status === 'to_be_approved' || status === 'invite_scheduled') eventSteps[2].completed = true
    if (status === "invite_scheduled" || status === "invited") eventSteps[2].completed = true
  } else if (status === undefined) {
    eventSteps[0].completed = true
    eventSteps[1].completed = false
    eventSteps[2].completed = false
  }


  return steps;
}


export const readImage = (url, callback) => {
  var request = new
    XMLHttpRequest(); request.onload = function () {
      var file = new FileReader();
      file.onloadend = function () {
        callback(file.result);
      }
      file.readAsDataURL(request.response);
    };
  request.open('GET', url);
  request.responseType = 'blob';
  request.send();
}

export const parseBody = (text) => {
  var newL = /\n/g;
  return text.replace(newL, '<br/>');
}

export const hasPendingChanges = (values, draftEvent) => {
  const keys = [
    "message",
    "startAt",
    "endAt",
    "title",
    "address",
    "additionalGuestAllowed",
    "ctaText",
    "maxAdditionalGuests",
    "maxNoOfGuests",
    "messageTitle",
    "placeName",
    "eventType",
    "fields",
    "recurrenceEndDate",
    "recurrenceType",
    "recurringDaysList",
    "recurringEventType",
    "repeatType",
    "rsvpFormHeader",
    "zoomLink",
    "meetingId",
    "passcode",
    "docData",
    "imageData",
  ];
  for (let i = 0; i < keys.length; i++) {
    if (keys[i] === "startAt" || keys[i] === "endAt") {
      let d1 = new Date(values[keys[i]]).toString();
      let d2 = new Date(draftEvent[keys[i]]).toString();
      if (d1 !== d2) return true;
    } else if (keys[i] === "message") {
      let m1 = brToNl(values[keys[i]], true);
      let m2 = brToNl(draftEvent[keys[i]], true);
      if (m1 !== m2) return true;
    } else if (values[keys[i]] && values[keys[i]] != draftEvent[keys[i]]) {
      return true;
    }
  }
}